<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.booking')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('header.mall') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('header.cart') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <car-list
      v-if="cartInfoShow && cartInfoShow.length > 0"
      ref="mycar"
      :carList="carListNew"
      :totalPrice="cartAllPriceShow"
      :totalNum="cartAllNumShow"
      @allSelBtn="allSelBtn"
      @selShop="selShop"
      @selGoods="selGoods"
      @jsbtn="jsbtn"
      @delbtn="delbtn"
      @changeNum="changeNum"
      @deleteGoodsItem="deleteGoodsItem"
    ></car-list>
    <div class="empty-cart" v-else>
      <img src="@/assets/images/empty-cart.png" />
      <p>购物车暂无商品</p>
    </div>
    <el-dialog
      title="删除商品提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <p>您确定要删除该商品吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import carList from '@/components/car-list/car-list.vue';
import routerTo from '@/router/routerTo';
export default {
  components: {
    carList,
  },
  data() {
    return {
      carListNew: [],
      dialogVisible: false,
      deleteCarList: [], //删除
      deleteDict: {},
      deleteShopIndex: -1,
      deleteGIndex: -1,
      currentType: -1,
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    cartInfoShow() {
      return this.$store.getters.cartInfoShow;
    },
    cartAllPriceShow() {
      return this.$store.getters.cartAllPriceShow;
    },
    cartAllNumShow() {
      return this.$store.getters.cartAllNumShow;
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    this.combinationShopData();
  },
  methods: {
    deleteOrderConfirm() {
      let that = this;
      that.deleteCarList[that.deleteShopIndex].glist.splice(
        this.deleteGIndex,
        1,
      ); //添加为0时移除
      that.carListNew = that.deleteCarList;
      that.$store.commit('removeCartItem', that.deleteDict);
      that.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    combinationShopData() {
      let itemDict = {};
      itemDict.title = localStorage.getItem('store_name');
      itemDict.total = this.cartInfoShow.length;
      itemDict.goodsAmount = this.cartAllPriceShow;
      itemDict.selected = true;
      itemDict.shopId = 1;
      let glist = [];
      this.cartInfoShow.forEach((cartItem) => {
        let glistItem = {};
        glistItem.selected = true;
        glistItem._id = cartItem._id;
        glistItem.goods_name = cartItem.goods_name;
        glistItem.image = cartItem.image;
        glistItem.price = cartItem.price;
        glistItem.buy_num = cartItem.buy_num;
        glistItem.stock = cartItem.stock;
        glistItem.spec_key_name = cartItem.sku_name_arr.join();
        glistItem.goods_id = cartItem.goods_id;
        //glistItem.merchant_code = cartItem.merchant_code;
        glist.push(glistItem);
      });
      itemDict.glist = glist;
      this.carListNew.push(itemDict);
      console.log('哈哈哈哈哈哈', this.carListNew);
    },
    confirm: function() {
      //确定按钮
      console.log('您点击了确定按钮');
    },
    cancel: function() {
      //取消按钮
      console.log('您点击了取消按钮');
    },
    selGoods: function(carList) {
      var that = this;
      /*that.carList = carList;*/
      that.carListNew = carList;
    },
    selShop: function(carList) {
      var that = this;
      /*that.carList = carList;*/
      that.carListNew = carList;
    },
    allSelBtn: function(carList) {
      var that = this;
      /*that.carList = carList;*/
      that.carListNew = carList;
    },
    jsbtn: function(ids) {
      //结算按钮
      var that = this;
      console.log(ids, JSON.stringify(this.carListNew));
      /* 
          跳转结算页面
        */
      routerTo.toSubmitOrder(this.$router, false, {
        ids: ids,
        cartList: JSON.stringify(that.carListNew),
      });
      // uni.navigateTo({
      //   url: `/pages/submitOrders/submitOrders?ids=${ids}&cartList=${JSON.stringify(
      //     this.carListNew
      //   )}`,
      // });
    },
    delbtn: function(ids, list) {
      //删除按钮
      var that = this;
      /* 
          请求接口数据
        */
      console.log('点击了删除按钮');
      for (let i = 0; i < list.length; i++) {
        for (let k = 0; k < list[i].glist.length; k++) {
          if (list[i].glist[k].selected == true) {
            list[i].glist.splice(k, 1);
            k--;
          }
        }
        if (list[i].glist.length == 0) {
          //若当前店铺商品删除完，删除当前店铺
          list.splice(i, 1);
          i--;
        }
      }
      /*that.carList = carList;*/
      that.carListNew = list;
      console.log('这是', JSON.stringify(that.carListNew));
      // that.$refs.mycar.getAllMount(list);//计算价格展示
    },
    changeNum: function(
      total,
      carList,
      shopIndex,
      gIndex,
      number,
      id,
      type,
      goods_id,
      stock,
      deleteGoodsItem,
    ) {
      console.log('number', number, type);
      var that = this;
      carList[shopIndex].glist[gIndex].buy_num = number;
      if (type == 0) {
        carList[shopIndex].total = total - 1;
      } else {
        carList[shopIndex].total = total + 1;
      }
      /*that.carList = carList;*/
      let dict = {};
      dict._id = id;
      dict.goods_id = goods_id;
      dict.number = number;
      dict.stock = stock;
      //cart.changeCartBuyNum(dict);
      this.$store.commit('changeCartBuyNum', dict);
      if (deleteGoodsItem) {
        this.dialogVisible = true;
        this.deleteCarList = carList;
        this.deleteDict = dict;
        this.deleteShopIndex = shopIndex;
        this.deleteGIndex = gIndex;
      } else {
        that.carListNew = carList;
      }
      /*that.$refs.mycar.getAllMount(carList);//计算价格展示*/
    },
    deleteGoodsItem(carList, shopIndex, gIndex, id, goods_id) {
      this.dialogVisible = true;
      let dict = {};
      dict._id = id;
      dict.goods_id = goods_id;
      this.deleteCarList = carList;
      this.deleteDict = dict;
      this.deleteShopIndex = shopIndex;
      this.deleteGIndex = gIndex;
    },
  },
};
</script>
<style scoped lang="less">
.empty-cart {
  padding: 100px 0;
  text-align: center;
  img {
    width: 400px;
    margin-bottom: 10px;
  }
}
</style>
